import axios from "axios";
import { apiConfig, axiosConfigWithAuthorizationHeader } from "../../common/api";
import { VoteDTO } from "../../models/types";

export const voteFor = async (vote: VoteDTO, token: string) => {
  return axios.post(apiConfig.votingURL, vote, axiosConfigWithAuthorizationHeader(token));
};
